const Subscribe = ({ data }) => (
  <section id="subscribe" className="relative tc lh-copy white">
    <Img
      sizes={data.image.childImageSharp.sizes}
      alt=""
      className="fill"
      critical={true}
      style={{ position: `absolute`, zIndex: `-1` }}
    />
    <div className="bg-black-20 pv6">
      <div className="container">
        <Pitch data={data} />
        <MailChimp />
      </div>
    </div>
  </section>
)

export default Subscribe

/*
 *
 * Imports
 * 
 */

import React, { Fragment } from 'react'
import shortid from 'shortid'
import Img from '../components/base/Img'

/*
 *
 * Pitch
 * 
 */

const Pitch = ({ data }) => (
  <Fragment>
    <h2 className="heading">{data.heading}</h2>
    <h3 className="subheading mb4 pb3">{data.subheading}</h3>
    {data.paragraphs.map(paragraph => {
      return (
        <p
          key={shortid.generate()}
          dangerouslySetInnerHTML={{ __html: paragraph }}
          className="ml-auto mr-auto mb3 abeezee"
          style={{ maxWidth: `47ch` }}
        />
      )
    })}
  </Fragment>
)

/*
 *
 * MailChimp
 * 
 */

import MailChimpForm from '../components/MailChimpForm'

// TODO: update MailChimp address (after RW confirms her list email address or changes it to another working email address she can verify successfully)
const MailChimp = () => (
  <MailChimpForm
    url="https://pomegranateopera.us17.list-manage.com/subscribe/post?u=803b1f04cfc2d6d009324b342&amp;id=b8e695f7be"
    firstName={true}
    formClasses="lg:flex lg:justify-center ml-auto mr-auto pt4 measure-tight lg:measure"
    labelClasses="lg:w-third lg:mr3"
    inputClasses="mb4 lg:mb0 br3 ph3 pv2 w-100 mid-gray"
  />
)



// WEBPACK FOOTER //
// ./src/sections/Subscribe.js